function u8_to_base64(u8) {
  let res='', len = u8.byteLength, _cc=String.fromCharCode;
  for (let i=0; i<len; i++) {
    res += _cc(u8[i]);}
  return btoa(res)}

function base64_to_u8(str_b64) {
  let sz = atob(str_b64.replace(/-/g, '+').replace(/_/g, '/'));
  let len = sz.length, u8 = new Uint8Array(len);
  for (let i=0; i<len; i++) {
    u8[i] = sz.charCodeAt(i);}
  return u8}

async function blob_to_dataurl(blob) {
  blob = await blob;
  let rdr = new FileReader();
  await new Promise (( onload, onerror ) => {
    rdr.onload = onload;
    rdr.onerror = onerror;
    rdr.readAsDataURL(blob);});
  return rdr.result}

const u8_to_base64url = /* #__PURE__ */ (()=>{
  let s = {'+':'-','/':'_','=':''};
  let m = c => s[c];
  let rx = /[+=\/]/g;
  return u8 => u8_to_base64(u8).replace(rx, m)
})();

export { base64_to_u8, blob_to_dataurl, u8_to_base64, u8_to_base64url };
//# sourceMappingURL=base64.js.map
